import { render, staticRenderFns } from "./publicDetails.vue?vue&type=template&id=1539614d&scoped=true&"
import script from "./publicDetails.vue?vue&type=script&lang=js&"
export * from "./publicDetails.vue?vue&type=script&lang=js&"
import style0 from "./publicDetails.vue?vue&type=style&index=0&id=1539614d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1539614d",
  null
  
)

export default component.exports